import { render, staticRenderFns } from "./bottom-left.vue?vue&type=template&id=bbbd3dec&scoped=true"
import script from "./bottom-left.vue?vue&type=script&lang=js"
export * from "./bottom-left.vue?vue&type=script&lang=js"
import style0 from "./bottom-left.vue?vue&type=style&index=0&id=bbbd3dec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbd3dec",
  null
  
)

export default component.exports